import { produce } from 'immer';
import { insert } from 'object-path';
import { fieldTemplatesState, layoutSelector } from 'state';
import { useRecoilState } from 'recoil';
import { clipboardAtom } from 'state/clipboardState';
import { LayoutItemType } from 'api/models/FormTemplate';
import { useSaveFormTemplate } from './useSaveFormTemplate';

interface UsePasteFieldProps {
  path: string;
  insertIndex?: number;
}

export default function usePasteField({
  path,
  insertIndex = 0,
}: UsePasteFieldProps) {
  const [layout, setLayout] = useRecoilState(layoutSelector);
  const [fieldTemplates, setFieldTemplates] =
    useRecoilState(fieldTemplatesState);
  const { save } = useSaveFormTemplate({ showToast: false });

  const [clipboard, setClipboard] = useRecoilState(clipboardAtom);
  const { layoutItem, fieldTemplates: copiedFieldTemplates = [] } =
    clipboard ?? {};

  return function () {
    let updatedTemplates;
    let updatedLayout;

    switch (layoutItem?.type) {
      case LayoutItemType.Container:
      case LayoutItemType.Static:
        if (layoutItem) {
          updatedTemplates = [...fieldTemplates, ...copiedFieldTemplates];
          updatedLayout = produce(layout, draft =>
            insert(draft, path, layoutItem, insertIndex),
          );
        }
        break;
      case LayoutItemType.Input:
      default:
        if (fieldTemplates && layoutItem) {
          updatedTemplates = [...fieldTemplates, ...copiedFieldTemplates];
          updatedLayout = produce(layout, draft =>
            insert(draft, path, layoutItem, insertIndex),
          );
        }
    }

    setFieldTemplates(updatedTemplates!);
    setLayout(updatedLayout!);
    save({ items: updatedLayout?.children, templates: updatedTemplates });

    setClipboard(undefined);
  };
}
